import { Star } from "lucide-react";

// Display-only stars — supports fractional average with a right-clipped overlay.
export function StarsDisplay({ value = 0, size = 14, className = "" }) {
  const v = Math.max(0, Math.min(5, Number(value) || 0));
  const pct = (v / 5) * 100;
  return (
    <div className={`relative inline-flex items-center ${className}`} aria-label={`${v.toFixed(1)} out of 5 stars`}>
      <div className="flex items-center gap-0.5 text-slate-300">
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} width={size} height={size} strokeWidth={1.5} />
        ))}
      </div>
      <div className="absolute inset-y-0 left-0 overflow-hidden" style={{ width: `${pct}%` }}>
        <div className="flex items-center gap-0.5 text-[#10B981]">
          {[0, 1, 2, 3, 4].map((i) => (
            <Star key={i} width={size} height={size} strokeWidth={1.5} className="fill-[#10B981]" />
          ))}
        </div>
      </div>
    </div>
  );
}

// Interactive 1-5 star picker.
export function StarsInput({ value, onChange, size = 22, testIdPrefix = "star" }) {
  return (
    <div className="inline-flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n)}
          data-testid={`${testIdPrefix}-${n}`}
          aria-label={`Rate ${n} out of 5`}
          className="p-1 -m-1 transition-transform hover:scale-110 active:scale-95"
        >
          <Star
            width={size}
            height={size}
            strokeWidth={1.6}
            className={n <= (value || 0) ? "fill-[#10B981] text-[#10B981]" : "text-slate-300"}
          />
        </button>
      ))}
    </div>
  );
}
